import React from 'react';

const SITE = 'https://theseoconsultant.ai';

export const Footer: React.FC = () => (
  <footer className="site-footer">
    <div className="container">
      <div className="footer-grid">
        <div>
          <a href={SITE} className="logo">
            The&nbsp;SEO&nbsp;Consultant<span className="dot">.</span><span className="ai">ai</span>
          </a>
          <p className="footer-blurb">
            SEO + AI Search consulting from Alameda, CA. Writing and tools by Richard Wong.
          </p>
        </div>
        <div className="footer-col">
          <h4>Work</h4>
          <a href={`${SITE}/ai-seo-consultant/`}>AI SEO Consultant</a>
          <a href={`${SITE}/travel-seo-consultant/`}>Travel SEO</a>
          <a href={`${SITE}/real-estate-seo-consultant/`}>Real Estate SEO</a>
          <a href={`${SITE}/enterprise-seo-consultant/`}>Enterprise SEO</a>
          <a href={`${SITE}/b2b-seo-consultant/`}>B2B SEO</a>
          <a href={`${SITE}/small-business-seo-consultant/`}>Small Business SEO</a>
        </div>
        <div className="footer-col">
          <h4>Tools</h4>
          <a href={`${SITE}/ai-seo-tools/`}>All Tools</a>
          <a href={`${SITE}/ai-mode-query-fan-out-analyzer/`}>Query Fan-Out Analyzer</a>
          <a href={`${SITE}/schema-markup-generator/`}>Schema Markup Generator</a>
          <a href="https://www.querydrift.com/" target="_blank" rel="noreferrer">QueryDrift (SaaS)</a>
        </div>
        <div className="footer-col">
          <h4>Elsewhere</h4>
          <a href="https://github.com/rwongphoto">GitHub</a>
          <a href="https://www.linkedin.com/in/googlepanda/">LinkedIn</a>
          <a href={`${SITE}/blog/`}>Blog</a>
        </div>
      </div>
    </div>
    <div className="footer-legal">
      <span>© {new Date().getFullYear()} The SEO Consultant.ai LLC</span>
      <span>Alameda, California</span>
    </div>
  </footer>
);
